import {
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from 'approot/activity-builder/activity-builder-drawer';
import { ActivityBuilderDrawerContent } from 'approot/activity-builder/activity-builder-drawer.style';
import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';
import {
  SettingSmallText,
  SettingSubHeading,
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import { useClassSettings } from 'approot/classes/class-settings.hooks';
import Bouncer from 'approot/shared/bouncer/bouncer';
import { WarningBanner } from 'approot/shared/design-system/banner/banner';
import { Box } from 'approot/shared/design-system/box/box.style';
import { grey7 } from 'approot/shared/styles/colours.style';
import Text from 'approot/shared/styles/typography/text';
import Switch from 'approot/shared/switch/switch';

type Props = {
  onClose: () => void;
};

const PresentMenuSettings = ({ onClose }: Props) => {
  const { userClassId } = useGetInteractiveLessonParams();
  const classId = Number(userClassId);

  const {
    backgroundVisibility,
    animationAutoPlay,
    translationEnabled,
    translationEnabledStudent,
    loading,
    handleUpdate,
  } = useClassSettings(classId);

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader title="Settings" onClose={onClose} />
      <ActivityBuilderDrawerContent>
        {loading ? (
          <Bouncer />
        ) : (
          <>
            <SettingSubHeading>ACCESSIBILITY</SettingSubHeading>
            <SettingsGroup>
              <SettingsLabel>Show Background</SettingsLabel>
              <Box $marginBottom={4}>
                <Switch
                  ariaLabel={`Click to ${
                    backgroundVisibility ? 'hide' : 'show'
                  } backgrounds`}
                  state={backgroundVisibility}
                  onClick={() =>
                    handleUpdate({
                      classId,
                      backgroundVisibility: !backgroundVisibility,
                      animationAutoPlay,
                      translationEnabled,
                      translationEnabledStudent,
                    })
                  }
                />
              </Box>
              <SettingSmallText colour={grey7}>
                Displays backgrounds in lessons and assessments for everyone in
                this class.
              </SettingSmallText>
            </SettingsGroup>
            <SettingsGroup>
              <SettingsLabel>Animations</SettingsLabel>
              <Box $marginBottom={4}>
                <Switch
                  ariaLabel={`Click to ${
                    animationAutoPlay ? 'disable' : 'enable'
                  } animations and some interactive elements`}
                  state={animationAutoPlay}
                  onClick={() =>
                    handleUpdate({
                      classId,
                      backgroundVisibility,
                      animationAutoPlay: !animationAutoPlay,
                      translationEnabled,
                      translationEnabledStudent,
                    })
                  }
                />
              </Box>
              <SettingSmallText colour={grey7}>
                Enables animations and some interactive elements for this class
              </SettingSmallText>
              {!animationAutoPlay && (
                <WarningBanner $size="small">
                  <Text $colour="inherit" $fontSize={14}>
                    Some interactive elements may not work when this is off.
                  </Text>
                </WarningBanner>
              )}
            </SettingsGroup>
          </>
        )}
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default PresentMenuSettings;
